// extracted by mini-css-extract-plugin
export default {"container":"uQWU","pagesWrapper":"nGvP","page":"EqlQ","paginationLeft":"Xzag","paginationRight":"gv9n","disabledPage":"xN6R","currentPage":"pdfU"};